import { Autocomplete, Backdrop, Grid, IconButton, TextField, Typography } from '@mui/material'
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import axios from 'axios'
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import _ from 'lodash'
import React, { Fragment, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers'
import dayjs from 'dayjs';
import moment from 'moment';
import CustomTable from '../customTable';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModalTable from './otClosingReportModal';

const OtClosingStockReports = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const pageOption = [10, 25, 50, 100];
    const [page, setPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const outletId = localStorage.getItem('outlet_id')
    const roleId = localStorage.getItem("role_id")
    const[cust, setCust] = useState(null)
    const [data,setData] = useState([])
    const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
    const [supplier, setSupplier] = useState([]);
    const [catData, setCatData] = useState([]);
    const [allSubData, setAllSubData] = useState([]);
    const [subData, setSubData] = useState([]);
    const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
    const [rowData, setRowData] = useState(null)
    const [open , setOpen] = useState(false)
    const[salesLines , setSalesLines] = useState([])
    const [search, setSearch] = useState("");

    const [dateLimit, setDateLimit] = useState({
        fromDate : roleId != 1 && roleId != 2 ? moment().format() : moment().startOf('month').format(),
        toDate :  moment().format()
      })
      const [options, setOptions] = useState({
        category: null,
        subCategory: null,
      });
    function handleChange(e, name) {
        setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
      }
      function handleChangeValue(value, name) {
        setOptions((prev) => ({ ...prev, [name]: value }));
        if (name === "category") {
          setOptions((prev) => ({ ...prev, subCategory: null }));
          filterSubCategories(value ? value.id : null);
        }
      }
      function filterSubCategories(categoryId) {
        if (categoryId) {
          const filteredSubData = allSubData.filter(
            (sub) => sub.category_id === categoryId
          );
          setSubData(filteredSubData);
        } else {
          setSubData([]);
        }
      }
      function getCategory() {
        axios
          .get("/v1/categories")
          .then((res) => {
            const activeCategories = _.filter(res.data, (val) => val.is_active);
            setCatData(activeCategories);
          })
          .catch((err) => {
            console.log(err);
            dispatch(setSnackbar(true, "error", err.response.data.error));
          });
      }
      function getSubCategory() {
        axios
          .get("/v1/subcategories")
          .then((res) => {
            setAllSubData(res.data);
          })
          .catch((err) => {
            console.log(err);
            dispatch(setSnackbar(true, "error", err.response.data.error));
          });
      }
    function getSupplierData() {
        axios
          .get("/v1/outlet/list/1")
          .then((res) => {
            _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val))
            setSupplier(res.data);
          })
          .catch((err) => {
            dispatch(setSnackbar(true, "error", err.response.data.error));
          });
      }
      const onEdit = (e) => {
        console.log(e.row)
        setSalesLines(e.row.sales_lines)
        setRowData(e.row)
        setOpen(true)
      }
      console.log(data,"datadata");
      
      const columns = [
        {
            field : 'sno',
            headerName:'S.no',
            minWidth:70,
            headerAlign:'center',
            align:'center',
            sortable:false
        },
        {
            field: "docDate",
            headerName: "Date",
            minWidth: 180,
            headerAlign: "center",
            align: "center",
            sortable: false,
        },
        {
            field: "sales_man_name",
            headerName: "Sales Man Name",
            minWidth: 200,
            headerAlign: "center",
            align: "center",
            sortable: false,
        },
        // {
        //     field: "pro_name",
        //     headerName: "Product Name",
        //     minWidth: 200,
        //     flex:1,
        //     headerAlign: "center",
        //     align: "center",
        //     sortable: false,
        // },
        {
            field: "category_name",
            headerName: "Category Name",
            minWidth: 200,
            headerAlign: "center",
            align: "center",
            sortable: false,
        },
        {
            field: "subcategory_name",
            headerName: "Subcategory Name",
            minWidth: 200,
            headerAlign: "center",
            align: "center",
            sortable: false,
        },
        {
            field: "item_count",
            headerName: "Total Scan Qty",
            minWidth: 200,
            headerAlign: "center",
            align: "center",
            sortable: false,
        },
        
        {
          field: "view",
          headerName: "View",
          minWidth: 130,
          headerAlign: "center",
          align: "center",
          sortable: false,
          disableExport: true ,
          renderCell: (params) => {
            return (
              <div>
                <IconButton size="small" onClick={() => onEdit(params)}
                   disabled={roleId != 1 && roleId != 2}
                  ><VisibilityIcon /></IconButton>
                  {/* <IconButton size="small" onClick={()=>handleThermal(params.row)}><Print sx={{fontSize: 18}}/></IconButton> */}
      
              </div>
              
            );
          },
        }, 

      ]
      const rows = _.map(data,(val,idx) =>({
        id: val.id || idx + 1,
        
        sno:idx+1,
        docDate:moment(val.docdate).format('DD-MM-YYYY'),
        sales_man_name:val.sales_man_name,
        pro_name:val.pro_name,
        category_name:val.category_name,
        subcategory_name:val.subcategory_name,
        item_count: val.item_count,
        sales_lines: val.sales_lines,
        totalAmount: val.total_mrp ,
        // totalAmount: (parseFloat(val.item_count) * parseFloat(val.mrp)).toFixed(2),

      }))
      console.log(rows,"rows");
      
      const props = {
        columns : columns,
        rows : rows,
        page: page,
        search: search,
        setSearch: setSearch,
        setPage: setPage,
        rowsPerPage: rowsPerPage,
        setRowsPerPage: setRowsPerPage,
        pageCount: pageCount,
        pageOption: pageOption,
        totalAmount:totalAmount,
        totalFlag:totalFlag
      }
      const tableHeadData = [
        { id:1, label: "S No" },
        { id:2, label: "Barcode" },
        { id:3 , label:"Product Name"},
        { id:4, label:"Category Name"},
        { id:5, label:"Subcategory Name"},
        { id:6 , label:"Mrp"},

      ];
      const tableBodyData = _.map(salesLines, (val,idx) => ({
        id:idx,
        sNo:idx+1,
        name:val.barcode,
        Mrp:val.mrp,
        pro_name:val.pro_name,
        category_name:val.category_name,
        subcategory_name:val.subcategory_name,
        // totalAmount : parseFloat( val.qty * val.mrp ).toFixed(2)
      }))
      console.log(salesLines,"salesLines");
      
      function closingStockReports(){
        const closingData = {
            from_date : moment(dateLimit.fromDate).format('YYYY-MM-DD'),
            to_date : moment(dateLimit.toDate).format('YYYY-MM-DD'),
            outlet:cust!==null ? cust.id : outletId,
            category_id:options.category != null ? options.category.id : 0,
            subcategory_id:options.subCategory != null ? options.subCategory.id : 0,
            search: search || '',
          }
        axios.post(`/v1/reports/closing/stock/outlet`,closingData )
        .then(res=>{
          setData(res.data)
          setPageCount(res.data.length) 
          console.log(res.data,"response");
                  
        })
        .catch(err=>{
            console.log(err)
          // dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
          setData([])
        })
      }
      useEffect(() => {
        getSupplierData();
        getCategory();
        getSubCategory();
      }, []);
      useEffect(() => {
        if (options.category) {
          filterSubCategories(options.category.id);
        }
      }, [options.category]);
      useEffect(() => {
        closingStockReports()
      },[rowsPerPage, page, dateLimit, cust , options,search])
  return (
    <Fragment>
        <Helmet><title>Outlet Closing Stock Reports</title></Helmet>
      <Typography variant="h6">Outlet Closing Stock Reports</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format="DD-MM-YYYY"
              // disabled={roleId != 1 && roleId != 2} 
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'},
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format="DD-MM-YYYY"
              // disabled={roleId != 1 && roleId != 2} 
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <Autocomplete 
            size="small"
            value={cust}
            options={supplier}
            onChange={(e,value)=>setCust(value)}
            getOptionLabel={option=>option.fullname} 
            disabled={roleId != 1 && roleId != 2} 
            renderInput={(params) => <TextField {...params} label="Select Outlet"
            InputProps={{
              ...params.InputProps,
              readOnly: true,
            }}  
            />}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
            <Autocomplete
              size="small"
              value={options.category}
              options={catData}
              getOptionLabel={(option) => option.category_name}
              onChange={(e, value) => handleChangeValue(value, "category")}
              renderInput={(params) => (
                <TextField {...params} label="Category" />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Autocomplete
              size="small"
              options={subData}
              value={options.subCategory}
              getOptionLabel={(option) => option.subcategory_name}
              onChange={(e, value) => handleChangeValue(value, "subCategory")}
              disabled={options.category == null}
              renderInput={(params) => (
                <TextField {...params} label="Sub Category" />
              )}
            />
          </Grid>
           <Grid item md={3}>
                    <TextField size="small" placeholder= "search"              onChange={(e) => setSearch(e.target.value)}
                    />
                  </Grid>
        {/* <Grid item md={3} style={{ display: 'flex', alignItems: 'center' }}>
        <CSVLink
          data={generateCSVData(dateLimit.fromDate, dateLimit.toDate, cust)}
          filename={`outlet_sales_report_${moment().format("YYYY-MM-DD")}.csv`}
        >
          <Button variant="contained">Download CSV</Button>
        </CSVLink>
        </Grid> */}
      </Grid>
      <CustomTable props={props}/>
      <Backdrop open={open} sx={{zIndex:9999}}>
        <ModalTable tableHeadData={tableHeadData} tableBodyData={tableBodyData} setOpen={setOpen} data={rowData}/>
      </Backdrop>
    </Fragment>
  )
}

export default OtClosingStockReports